<ul class="accommodation-options">
  <li class="accommodation-options__shared-room" data-qa="accommodationOptions_room_type">
    <div>{{ roomType }}</div>
  </li>
  <li class="accommodation-options__shared-bathroom" data-qa="accommodationOptions_bathroom">
    <div>{{ bathroomType | lxAccommodationLabelOptions : 'bathRoomTypeLabels' }}</div>
  </li>
  <li class="accommodation-options__meals" data-qa="accommodationOptions_meals">
    <div>{{ mealOptions | lxAccommodationLabelOptions : 'mealOptionLabels' }}</div>
  </li>
</ul>
